'use client';

import { ReactNode, use } from 'react';
import dayjs from 'dayjs';

import { EmptyGrassTile, GrassTile } from './GrassTile';
import {
  GrassCalendarContainer,
  DEFAULT_GRASS_COUNT,
} from './GrassCalendar.parts';

import { GrassWidgetProps } from '@/shared/types';

interface GrassCalendarProps extends GrassWidgetProps {
  todayGrassTileComponent: ReactNode;
  isAuth: boolean;
}

const GrassCalendar = ({
  grassListPromise,
  todayGrassTileComponent,
  isAuth,
}: GrassCalendarProps) => {
  if (!isAuth) return null;

  const { grassList } = use(grassListPromise);
  const startDate = dayjs().startOf('year');
  const startDay = startDate.day();
  const leftDay = DEFAULT_GRASS_COUNT - startDay - grassList.length;

  return (
    <GrassCalendarContainer>
      {Array.from({ length: startDay }).map((_, index) => (
        <EmptyGrassTile key={`before-${index}`} id={`before-${index}`} />
      ))}
      {grassList.map((grass) => {
        const isToday = dayjs().isSame(grass.date, 'day');
        return isToday ? (
          todayGrassTileComponent
        ) : (
          <GrassTile key={grass.date} {...grass} />
        );
      })}
      {Array.from({ length: leftDay }).map((_, index) => (
        <EmptyGrassTile key={`after-${index}`} id={`after-${index}`} />
      ))}
    </GrassCalendarContainer>
  );
};

export default GrassCalendar;
